export type PdfCopyType = 'laboratory' | 'mro' | 'collector' | 'employer' | 'donor';
export type PdfCopyOptions = PdfCopyType[] | 'all' | 'consent' | 'initial';
type PdfDocumentType = 'usRegulated' | 'usUnregulated';
type CopiesMap = Record<PdfDocumentType, Record<PdfCopyType, { label: string, translationKey: string, pages: number[] }>>;

export const PdfCopiesMap: CopiesMap = {
	usRegulated: {
		laboratory: {
			label: 'Laboratory Copy',
			translationKey: 'CcfPwa_LabCopyLabel',
			pages: [ 0, 4 ]
		},
		mro: {
			label: 'MRO Copy',
			translationKey: 'CcfPwa_MroCopyLabel',
			pages: [ 1, 4 ]
		},
		collector: {
			label: 'Collector Copy',
			translationKey: 'CcfPwa_CollectorCopyLabel',
			pages: [ 2, 4 ]
		},
		employer: {
			label: 'Employer Copy',
			translationKey: 'CcfPwa_EmployerCopyLabel',
			pages: [ 3, 4 ]
		},
		donor: {
			label: 'Donor Copy',
			translationKey: 'CcfPwa_DonorCopyLabel',
			pages: [ 5, 6 ]
		}
	},
	usUnregulated: {
		laboratory: {
			label: 'Laboratory Copy',
			translationKey: 'CcfPwa_LabCopyLabel',
			pages: [ 0 ]
		},
		mro: {
			label: 'MRO Copy',
			translationKey: 'CcfPwa_MroCopyLabel',
			pages: [ 1 ]
		},
		collector: {
			label: 'Collector Copy',
			translationKey: 'CcfPwa_CollectorCopyLabel',
			pages: [ 2 ]
		},
		employer: {
			label: 'Employer Copy',
			translationKey: 'CcfPwa_EmployerCopyLabel',
			pages: [ 3 ]
		},
		donor: {
			label: 'Donor Copy',
			translationKey: 'CcfPwa_DonorCopyLabel',
			pages: [ 4 ]
		}
	}
};

function onlyUnique( value: unknown, index: number, array: unknown[] ) {
	return array.indexOf( value ) === index;
}

export function getPageIndices( documentType: PdfDocumentType, pagesToInclude: PdfCopyType[] | PdfCopyType | 'all' | 'consent' | 'initial' ): number[] {
	const pdfCopies = PdfCopiesMap[ documentType ];

	if ( pagesToInclude === 'consent' ) {
		return [];
	}

	if ( pagesToInclude === 'all' || pagesToInclude === 'initial' ) {
		return Object.entries( pdfCopies ).flatMap( ( [ , pageType ] ) => pageType.pages ).filter( onlyUnique ).sort();
	}

	if ( Array.isArray( pagesToInclude ) ) {
		return pagesToInclude.flatMap( pageName => pdfCopies[ pageName ].pages ).filter( onlyUnique ).sort();
	}

	return pdfCopies[ pagesToInclude ].pages;
}

export const DownloadedCollectionTypeMap = {
	'laboratory': {
		order: 1,
		typeId: 41,
		typeKey: 'pdfLab'
	},
	'mro': {
		order: 2,
		typeId: 42,
		typeKey: 'pdfMro'
	},
	'collector': {
		order: 3,
		typeId: 43,
		typeKey: 'pdfCollector'
	},
	'employer': {
		order: 4,
		typeId: 44,
		typeKey: 'pdfEmployer'
	},
	'donor': {
		order: 5,
		typeId: 45,
		typeKey: 'pdfDonor'
	},
	'testresults': {
		order: 6,
		typeId: 33,
		typeKey: 'pdfTestResult'
	}
};

export type CopyType = keyof typeof DownloadedCollectionTypeMap;
